import { useEffect } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import accountPayableCardFilterList from "../../components/accountPayableCards/filter/accountPayableCardFilterList";
import AccountPayableCardExpandList from "../../components/accountPayableCards/expand/AccountPayableCardExpandList";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountPayableCardFooterList from "../../components/accountPayableCards/footer/AccountPayableCardFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const ExpandAll = () => {
  useEffect(() => {
    const expandAllBtn = document.querySelector(
      "table.RaDatagrid-table .RaDatagrid-thead .RaDatagrid-headerRow .RaDatagrid-expandHeader .RaDatagrid-expandIcon:not(.RaDatagrid-expanded)"
    );
    if (expandAllBtn) {
      var clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      expandAllBtn.dispatchEvent(clickEvent);
    }
  }, []);
  return null;
};

const AccountPayableCardList = () => {
  const { canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  return (
    <ManualReportList
      title="mine.list_title.account_payable_card"
      empty={false}
      actions={<DownloadAction />}
      filters={accountPayableCardFilterList}
      sort={{ field: "suppliers.id", order: "ASC" }}
      filterDefaultValues={filterDefaultValues}
      requiredFilters={["start_date", "end_date"]}
      // queryOptions={{ meta: { sort: ["suppliers.created_at ASC"] } }} // overide default sort
    >
      <DatagridConfigurable
        body={<MyDatagridBody footer={<AccountPayableCardFooterList />} />}
        bulkActionButtons={false}
        expand={<AccountPayableCardExpandList />}
        isRowExpandable={(row) =>
          row.company_debt_items && !!row.company_debt_items.length
        }
        sx={{
          "& .RaDatagrid-expandedPanel > td": {
            p: 0,
            bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
          },
        }}
        >
        {canSeeCompanyColumn ? (
          <TextField label="mine.label.depo" source="company_alias" />
        ) : null}
        <TextField source="code" label="mine.label.supplier_code" />
        <ExpandAll />
        <TextField source="name" label="mine.label.supplier_name" />
        <NumberField
          source="total_initial"
          label="mine.label.initial_balance"
        />
        <NumberField source="total_debit" label="mine.label.debit" />
        <NumberField source="total_credit" label="mine.label.credit" />
        <NumberField source="total_final" label="mine.label.final_balance" />
      </DatagridConfigurable>
    </ManualReportList>
  );
};

export default AccountPayableCardList;
